const { ccclass } = cc._decorator;
import ModuleBase, { ViewLayer, bindButtonClickEvent, moduleInit } from "../../../../framework/core/mvvm/module_base";
import RecordView from "./record_view";
import AppData from "../../../public/const/app_data";
import ModelData from '../../../public/model_data';
import ModuleManager from "../../../../framework/core/module_manager";

@ccclass
@moduleInit("Record")
export default class Record extends ModuleBase<RecordView, null>  {

    constructor() {
        super()
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = 'package/hall/module/record/record_table';       
        this.viewType = RecordView;

        this.needAnim = true
        this.needViewMask = true
        this.autoShowAnim = true
        this.needViewBaseBg = true    
        this.needViewBaseCloseBtn = true    
        this.needViewBaseTitleBg = true
        this.needDeferShow = true
    }

    protected onDeferShow(intentData) {
        this.getRecordData()
    }


    protected onButtonClickName(name : string) {
        switch (name) {
            case "CloseBtn":
                ModuleManager.instance.destroyModule("Record")
                break;
            case "playbackBtn":
                ModuleManager.instance.toast("即将开放！")
                break;
            case "infoBtn":
                
                break;
            default:
                break;
        }
    }

    //获取战绩数据
    getRecordData(){
        let self = this
        let requestData: IHttpRequestData = {
            baseUrl: "round/getRoundUserHistoryPage?",
            params: {
                uid: ModelData.instance.roleData.id,
                gameId: AppData.gameName,
                pageNum:1,
                pageSize:10,

                gameUserId: ModelData.instance.roleData.id,
                endTime:new Date().getTime(),
                startTime: new Date().getTime() - 1209600000//14*24*60*60*1000
            },
            showNetPrompt:true
        }
        this.apiHttpGet(requestData, (respone) => {
            self.show()
            self.view.updateShow(respone.data.list)
        })
    }
}